import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import ContactFormCmp from "../../components/ContactFormCmp";

const LayoutRegularisationScheme = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        location: "",
        budget: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const submitMessage = (e) => {
        e.preventDefault();
        // console.log(formData);
        // API call or validation logic here
        alert(
            'Due to some technical issues, we could not process your Form Submission.'
        );

        setFormData({
            fullName: "",
            email: "",
            phone: "",
            location: "",
            budget: "",
            message: "",
        });
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <>
            {/*Start breadcrumb area paroller*/}
            <section className="breadcrumb-area">
                <div className="breadcrumb-area-bg"style={{ backgroundImage: 'url(/assets/images/services/banners/GovernmentSchemes.jpg)' }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="inner-content">
                                <div className="title">
                                    <h2>Layout Regularisation Scheme</h2>
                                </div>
                                <div className="breadcrumb-menu">
                                    <ul>
                                        <li><Link to="/">Home</Link></li>
                                        <li><i className="fa fa-angle-right" aria-hidden="true" /></li>
                                        <li className="active">Layout Regularisation Scheme</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*End breadcrumb area*/}

            <div className="service-details-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="service-details-sec1">
                                <div className="d-flex">
                                    <div className="flex-shrink-0">
                                        <img className="serv-im" src="/assets/images/Group2.png" alt="Architecture Design" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h3 className="serv-head">Layout Regularisation Scheme (LRS)</h3>
                                        <p className="serv-txt">The Layout Regularisation Scheme (LRS) enables property owners to regularize plots in unauthorized layouts. Our
                                            experts assist with eligibility verification, documentation, and smooth application through the government portal.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="serv-sec2">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="serv-sec2-leftsec">
                                    <h3 className="serv-sec2-leftsec-head">What We Offer</h3>
                                    <p className="serv-sec2-leftsec-txt">The Layout Regularisation Scheme (LRS) helps property owners regularize plots in unauthorized layouts. Our experts assist in verifying eligibility, preparing required documentation, and completing the application process smoothly through the government portal.</p>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">LRS Application Filing</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Layout & Plot Verification</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Online Portal Submission</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Documentation & Compliance Support</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Layout Plan Preparation</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Authority Coordination & Follow-ups</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Regularisation Fee Calculation</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Complete LRS Processing Support</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="serv-sec-3box">
                                        <h3 className="serv-sec-3box-head">Key Benefits</h3>
                                        <ul className="serv-sec-3box-ul">
                                            <li>• ⁠Legal recognition for plots in unapproved layouts</li>
                                            <li>• ⁠Eligibility to obtain building permissions</li>
                                            <li>• ⁠⁠Increased property value and resale opportunities</li>
                                            <li>• Access to bank loans and financial services</li>
                                            <li>• ⁠Compliance with Andhra Pradesh planning regulations</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='contactus-section2Right'>
                                    <h3 className='contactus-section2RightHead'>Contact for Service</h3>
                                    <p className='contactus-section2Righttxt'>Fill in your details and we'll get back to you within 24 hours.</p>
                                    <ContactFormCmp serviceName="LRS" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default LayoutRegularisationScheme;